import { ActionCardData } from './types'

function resetLastActiveSeparator(ac: ActionCardData) {
  const isLastActiveSeparatorEnabled = ac.enabledSeparators.some(sepId => sepId === ac.lastActiveSeparator)

  if (isLastActiveSeparatorEnabled) {
    return
  }

  const lastEnabledSeparator = ac.enabledSeparators[ac.enabledSeparators.length - 1]

  if (lastEnabledSeparator) {
    ac.lastActiveSeparator = lastEnabledSeparator
  } else {
    ac.lastActiveSeparator = -1
  }

  return
}

export default resetLastActiveSeparator
